import styled from 'styled-components';

export const StyledSavePayElement = styled.button`
    background-color: ${({ isedit }) => (isedit ? '#5FEE5C' : '#6786be')};
    cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ $isDisabled }) => ($isDisabled ? '0.6' : '1')};
    width: 40px;
    height: 40px;
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
`;
